import ManageMForm from './manageMForm';
import './index.scss';

export default ManageMForm;
